import { render, staticRenderFns } from "./ResultadoCredenciais.vue?vue&type=template&id=b188e286&"
import script from "./ResultadoCredenciais.vue?vue&type=script&lang=js&"
export * from "./ResultadoCredenciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports